import { BalconyIcon } from './BalconyIcon';

/**
 * author: Google
 * id 005E0382-9004-4606-AA2A-07E27AF1E77E
 * name balcony
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/balcony.svg
 * tags
 * - Home Automation 
 */
export const VerandaIcon = BalconyIcon;
export default VerandaIcon